export const DRILL_DOWN_COLUMN_ATTRIBUTE = 'data-drilldown-column';
